import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions, Form, } from 'react-redux-form';
import {Col, FormGroup, Row} from 'react-bootstrap';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredMultiSelect from '../../../common/form/elements/required-multi-select';
import RequiredAutoRedemptionDate from './required-autoredemption-date';
import AutoRedemptionDate from './autoredemption-date';
import ArrowButton from '../../../common/button-arrow';
import {getStaffRewardSettings, getVouchers, saveStaffRewardSettings} from '../../../../actions/staff';
import t from '../../../../data/translations';
import RequiredDatepicker from '../../../common/form/elements/required-datepicker';

class StaffRewardSettingsForm extends Component {
  state = {
    value: ''
  };
  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_staff_reward.settings', saveStaffRewardSettings(payLoad)));
  };
  addAutoRedemptionDate = () => {
    this.props.dispatch(actions.push('deep.admin_staff_reward.settings.autoredemption_dates', ''));
  };
  onDeleteAutoRedemptionDate = (index) => {
    this.props.dispatch(actions.remove('deep.admin_staff_reward.settings.autoredemption_dates', index));
  };
  handleChange = () => {
  };

  componentWillMount() {
    this.props.dispatch(getStaffRewardSettings());
    this.props.dispatch(getVouchers());
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.savedVouchers
    });
  }

  render() {
    return (
      <Form model="deep.admin_staff_reward.settings" onSubmit={this.onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="ppe"
              label={`Points per ${t('currency')}`}
              model=".point_per_euro"
              placeholder="e.g. 100"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId="markupPercent"
              label="Reward Markup %"
              model=".reward_markup"
              placeholder="e.g. 10"
            />
          </Col>
        </Row>
        <Row>
          <Col className="vouchers-col" lg={12}>
            <RequiredMultiSelect
              controlId="availableVouchers"
              data={this.props.allVouchers.map(voucher => ({
                id: voucher.id,
                name: voucher.attributes.name
              }))}
              label="Available Vouchers"
              labelAttr="name"
              model='deep.admin_staff_reward.settings.available_vouchers'
              value={this.props.savedVouchers}
              valueAttr="id"
            />
          </Col>
        </Row>

        <RequiredAutoRedemptionDate/>
        {
          this.props.autoRedemptionDates.map((date, index) => (
            <AutoRedemptionDate
              index={index}
              key={index}
              onDelete={this.onDeleteAutoRedemptionDate}
            />
          ))
        }

        <Row>
          <Col lg={12}>
            <FormGroup>
              <ArrowButton
                arrow={false}
                color="grey"
                onClick={this.addAutoRedemptionDate}
                submit={false}
              >
                Add date
              </ArrowButton>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <RequiredDatepicker
              model="deep.admin_staff_reward.settings.postcodeplan_redemption_date"
              controlId="redemption_date"
              dateFormat="DD/MM/YYYY"
              label="Postcodeplan redemption dates"
              value={this.props.postcodeplanRedemptionDate || ''}
            />
          </Col>
          <Col lg={6} className="postcodeplan-redemption-frequency-container">
            <Row>
              <Col lg={3}>then every</Col>
              <Col lg={6}>
                <RequiredInput
                  type="number"
                  controlId="postcodeplan_redemption_frequency"
                  model="deep.admin_staff_reward.settings.postcodeplan_redemption_frequency"
                  positive
                />
              </Col>
              <Col lg={3}>weeks</Col>
            </Row>


          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              className="pull-right"
              color="grey"
              disabled={!this.props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>

    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_staff_reward.settings.$form.valid,
  autoRedemptionDates: state.deep.admin_staff_reward.settings.autoredemption_dates,
  savedVouchers: state.deep.admin_staff_reward.settings.available_vouchers,
  allVouchers: state.staff.redemptions.vouchers,
  postcodeplanRedemptionDate: state.deep.admin_staff_reward.settings.postcodeplan_redemption_date,
});

export default connect(mapStateToProps)(StaffRewardSettingsForm);



// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/staff-reward-settings-form.jsx